// extracted by mini-css-extract-plugin
export var displayNone = "_r8-6";
export var imgContainer = "_r8-2";
export var overflowHidden = "_r8-3";
export var productInfoCardButtonContainer = "_r8-5";
export var productTitleText = "_r8-4";
export var rightArrow = "_r8-1";
export var rightArrowContainer = "_r8-0";